import { render, staticRenderFns } from "./LightControlDialog.vue?vue&type=template&id=48dcb85a&"
import script from "./LightControlDialog.vue?vue&type=script&lang=js&"
export * from "./LightControlDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports